module.exports = __webpack_public_path__ + "media/images/logo_text_en-1c9f535cdd43b4f313fe41b4d0f7b164.svg";